const learnMoreBtns = document.querySelectorAll(".ibe6skhCOPOTQA2gl");
if (learnMoreBtns) {
  const htmlEl = document.querySelector("html");
  learnMoreBtns.forEach((learnMoreBtn) => {
    learnMoreBtn.style.cursor = "pointer";
    learnMoreBtn.addEventListener("click", () => {
      const learnMorePopup = document.querySelector(
        '.__instant[data-instant-id="bfnRaqGVhtbg8Wfo"]'
      );
      const closePopupBtn = document.querySelector(".ijseLoTSaWZH6QlgI");
      closePopupBtn.style.cursor = "pointer";

      learnMorePopup.style.display = "block";
      htmlEl.style.overflow = "hidden";
      closePopupBtn.addEventListener("click", () => {
        learnMorePopup.style.display = "none";
        htmlEl.style.overflow = "unset";
      });
    });
  });
}

let stepOneButtons = document.querySelectorAll(".iZXWtluCzkcxKHKR8");
if (stepOneButtons) {
  stepOneButtons.forEach((stepOneButton) => {
    stepOneButton.style.cursor = "pointer";
    stepOneButton.addEventListener("click", () => {
      const popupContainer =
        stepOneButton.parentElement.parentElement.parentElement.parentElement
          .parentElement.parentElement.parentElement.nextElementSibling;

      const stepOnePopup = popupContainer.querySelector(".__instant");

      const closeStepOnePopupBtn =
        popupContainer.querySelector(".close-button");
      closeStepOnePopupBtn.style.cursor = "pointer";

      stepOnePopup.style.display = "block";
      closeStepOnePopupBtn.addEventListener("click", () => {
        stepOnePopup.style.display = "none";
      });
    });
  });
}

const ingridientsPopupBtns = document.querySelectorAll(".i219cjMfgPCsnbhEo");

if (ingridientsPopupBtns) {
  ingridientsPopupBtns.forEach((ingridientsPopupBtn) => {
    ingridientsPopupBtn.style.cursor = "pointer";
    ingridientsPopupBtn.addEventListener("click", () => {
      const ingridientsPopupContainer =
        ingridientsPopupBtn.parentElement.parentElement.parentElement
          .parentElement.parentElement.parentElement.nextElementSibling;

      const ingridientsPopup =
        ingridientsPopupContainer.querySelector(".__instant");

      const closeIngridPopupBtn =
        ingridientsPopupContainer.querySelector(".close-button");
      closeIngridPopupBtn.style.cursor = "pointer";

      ingridientsPopup.style.display = "block";
      closeIngridPopupBtn.addEventListener("click", () => {
        ingridientsPopup.style.display = "none";
      });
    });
  });
}

const customPopupBtns = document.querySelectorAll(".iTgMxgGhhhsmrU6r2");

if (customPopupBtns) {
  customPopupBtns.forEach((customPopupBtn) => {
    customPopupBtn.style.cursor = "pointer";
    customPopupBtn.addEventListener("click", () => {
      const customPopupContainer =
        customPopupBtn.parentElement.parentElement.parentElement.parentElement
          .parentElement.parentElement.nextElementSibling;

      const customPopup = customPopupContainer.querySelector(".__instant");

      const closeCustomPopupBtn =
        customPopupContainer.querySelector(".close-button");
      closeCustomPopupBtn.style.cursor = "pointer";

      customPopup.style.display = "block";
      closeCustomPopupBtn.addEventListener("click", () => {
        customPopup.style.display = "none";
      });
    });
  });
}

const mainProductPopupBtns = document.querySelectorAll(
  ".main_product_popup_btn"
);
if (mainProductPopupBtns) {
  mainProductPopupBtns.forEach((mainProductPopupBtn) => {
    mainProductPopupBtn.addEventListener("click", () => {
      const popupContainer =
        mainProductPopupBtn.parentElement.parentElement.parentElement
          .parentElement.nextElementSibling;

      if (popupContainer) {
        const customPopup = popupContainer.querySelector(".__instant");

        const closePopupBtn = popupContainer.querySelector(".close-button");
        closePopupBtn.style.cursor = "pointer";

        customPopup.style.display = "block";
        closePopupBtn.addEventListener("click", () => {
          customPopup.style.display = "none";
        });
      }
    });
  });
}

// to open nail-picker
function showSelection() {
  document.getElementById("selection").style.display = "block";
  document.getElementById("selection").style.top = "10px";
  document.querySelector("body").classList.add("color-choose-active");
}
